import { Component } from '@angular/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-edit-pojavni-oblik',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditPojavniOblikComponent extends PrimeNGButtonOpenItemViewActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => {
        const rezidualno = (item as any)['en~pojavni_oblik~rezidualni_podaci'];

        return rezidualno;
      })
    );
  }
}
